import script from "./DoughtnutChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoughtnutChart.vue?vue&type=script&lang=ts&setup=true"

import "./DoughtnutChart.vue?vue&type=style&index=0&id=7513b840&lang=scss"

const __exports__ = script;

export default __exports__